
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/drivers/[id]",
      function () {
        return require("private-next-pages/drivers/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/drivers/[id]"])
      });
    }
  